import React from "react";
import "./PWall.scss";
import RegisterCard from "components/RegisterCard/RegisterCard";
import { useTranslation } from "react-i18next";

export default function PWall_CreateAccount({ onCompleted, onExit }) {
  const { t } = useTranslation();
  return (
    <>
      <div className="PWall_container">
        <div className="PWall_content">
          <div className="PWall_container__right">
            <div className="content"></div>
            <div className="PWall_footer">
              <RegisterCard onSuccess={onCompleted} isRemoveShadow={true} isTitle={true} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


